// src/components/CartaoManual.js
"use client"
import { useEffect, useMemo, useState } from "react"
import styles from "../styles/cartao-manual.module.css" // << novo css próprio
import axios from "axios"

const WhatsappIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path d="M21 12a9 9 0 1 1-3.3-6.9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.5 9.8c.2 1.2 1.1 2.5 2.1 3.5s2.3 1.9 3.5 2.1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.5 15.5l.7-2.4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default function CartaoManual({ pedidoId, valor = 0, nomeVaqueiro = "", nomeEvento = "" }) {
  const API = process.env.REACT_APP_API_URL
  const [destino, setDestino] = useState("")

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/gateways`)
        const phone = data?.credentials?.cartao_manual?.whatsappDestino || ""
        setDestino((phone || "").replace(/\D/g, ""))
      } catch (e) {
        console.warn("Falha ao carregar WhatsApp destino do Cartão Manual.", e)
      }
    })()
  }, [API])

  const msg = useMemo(() => {
    const v = Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    return `Olá! Gostaria de solicitar o *link de pagamento no cartão de crédito*.

• *Evento:* ${nomeEvento || "-"}
• *Pedido:* ${pedidoId || "-"}
• *Nome:* ${nomeVaqueiro || "-"}
• *Total:* ${v}

Obs.: pagamentos por cartão possuem acréscimo automático no momento da cobrança.`
  }, [pedidoId, valor, nomeVaqueiro, nomeEvento])

  const waLink = useMemo(() => {
    const encoded = encodeURIComponent(msg)
    return destino ? `https://wa.me/55${destino}?text=${encoded}` : `https://wa.me/?text=${encoded}`
  }, [destino, msg])

  return (
    <div className={styles["cartao-box"]}>
      <div className={styles["cartao-card"]}>
        <div className={styles["cartao-header"]}>
          <h3 className={styles["cartao-title"]}>Cartão de Crédito</h3>
          <p className={styles["cartao-description"]}>
            Para efetuar o pagamento através do cartão de crédito, entre em contato com nosso atendimento e peça o link de pagamento.
          </p>
        </div>

        <div className={styles["cartao-info-section"]}>
          <div className={styles["cartao-info-item"]}>
            <p className={styles["cartao-info-label"]}>Atenção</p>
            <p className={styles["cartao-info-text"]}>
              Na modalidade <strong>cartão de crédito</strong> existe um acréscimo no valor, gerado automaticamente pelo sistema de cobrança.
            </p>
          </div>
        </div>

        <p className={styles["cartao-whatsapp-message"]}>
          Clique no botão abaixo para solicitar o link de pagamento no WhatsApp.
        </p>

        <a href={waLink} target="_blank" rel="noreferrer" className={styles["btn-whatsapp"]}>
          <WhatsappIcon />
          Solicitar Link de Pagamento
        </a>
      </div>
    </div>
  )
}
